import React from 'react';
import * as d3 from 'd3';

import './Histogram.css';

export default class Histogram extends React.Component {

  constructor(props) {
    super(props);

    var range = this.props.range || this._defaultRange();

    this.state = {
      activeAnchor: null,
      range: range,
    };
  }

  _defaultRange() {
    var scale = this._xScale();
    return {
        max: scale.invert(100),
        min: scale.invert(0),
    };
  }

  _xScale() {
    var domain = d3.extent(this.props.data, (d) => { return d.key; });

    return d3.scaleLinear()
      .clamp(true)
      .domain(domain)
      .range([0, 100]);
  }

  _yScale() {
    var dataMax = d3.max(this.props.data, (d) => d.doc_count );

    if (dataMax < 50) {
      return d3.scaleLinear()
        .clamp(true)
        .domain([0, dataMax])
        .range([0, this.props.height]);
    }

    return d3.scaleLog()
      .clamp(true)
      .domain([1, dataMax])
      .range([0, this.props.height]);
  }

  _handleClick(event) {
    var value = this._clickValue(event);
    var range = this.state.range || this._defaultRange();

    var bound;
    var minDist = Math.abs(value - range.min);
    var maxDist = Math.abs(value - range.max);
    if (maxDist < minDist) {
      bound = 'max';
    } else {
      bound = 'min';
    }

    this._updateRange(event, bound);
    this.setState({activeAnchor: bound});

    var onMousemove = (e) => {
      this._updateRange(e, bound);
    };
    var onMouseup = (e) => {
      window.removeEventListener('mousemove', onMousemove);
      window.removeEventListener('mouseup', onMouseup);

      this._updateRange(e, bound);
      this.setState({activeAnchor: null});
      this.props.onChangeRange(this.state.range);
    };

    window.addEventListener('mousemove', onMousemove);
    window.addEventListener('mouseup', onMouseup);
  }

  _clickValue(event) {
    var scale = this._xScale();

    var svg = this.refs.svg;
    var bounds = svg.getBoundingClientRect();
    var x = event.clientX - bounds.left;
    var frac = x / bounds.width;
    var value = scale.invert(frac * 100);

    return value;
  }

  _updateRange(event, bound) {
    var value = this._clickValue(event);
    var range = this.state.range || this._defaultRange();
    range[bound] = value;
    if (range.min > range.max) {
      range.min = range.max;
    }
    this.setState({range: range});
  }

  componentWillReceiveProps(props) {
    this.setState({range: props.range});
  }

  render() {
    var data = this.props.data;
    var range = this.state.range;

    var x = this._xScale();
    var y = this._yScale();

    var textHeight = 10;
    var textPadding = 3;
    var barWidth = `${ 100 / data.length + 1 }%`;
    var barHeight = this.props.height - textHeight - textPadding;

    var bars = data.map((d) => {
      var height = y(d.doc_count);
      return (<rect
        className="bar"
        key={d.key}
        x={ x(d.key) + '%' }
        y={barHeight - height}
        width={barWidth}
        height={height} />);
    });

    var labels = (<g>
      <text fontSize={textHeight} dy={textHeight + textPadding} y={barHeight}>
        {this.props.formatter(range ? range.min : x.invert(0))}
      </text>
      <text textAnchor="end" fontSize={textHeight} dy={textHeight + textPadding} y={barHeight} x={this.props.width}>
        {this.props.formatter(range ? range.max : x.invert(100))}
      </text>
    </g>);

    var anchorWidth = 5;
    var anchorHeight = barHeight * 0.8;
    var anchorGap = (barHeight - anchorHeight) / 2;

    var min = x.invert(0);
    var max = x.invert(100);

    if (range) {
      min = range.min;
      max = range.max;
    }

    var activeAnchor = this.state.activeAnchor;
    var ranges = (<g>
      <rect className="selected-range" x={ x(min)+'%' } width={ (x(max)-x(min)) + '%' } y="0" height={barHeight} />
      <rect
          className={ activeAnchor === 'min' ? 'range-anchor active' : 'range-anchor' }
          x={ x(min)+ '%' } width={anchorWidth} y={anchorGap} height={anchorHeight} />
      <g transform={ `translate(${-anchorWidth / 2})` }>
        <rect
          className={ activeAnchor === 'max' ? 'range-anchor active' : 'range-anchor' }
          x={ x(max)+ '%' } width={anchorWidth} y={anchorGap} height={anchorHeight} />
      </g>
    </g>);

    return (<div className="histogram">
      <svg ref="svg" onMouseDown={this._handleClick.bind(this)} width={this.props.width} height={this.props.height}>
        {bars}
        <line className="rule" x1="0" y1={barHeight} x2={this.props.width} y2={barHeight} />
        {labels}
        {ranges}
      </svg>
    </div>);
  }
}

Histogram.defaultProps = {
  data: [],
  formatter: d3.format("f"),
}



// WEBPACK FOOTER //
// ./src/components/Histogram.js